module.exports = __webpack_public_path__ + "img/photo_250890871_1.8d0e009e.jpg";